import "./styles/general.css";

import MainPage from "./pages/MainPage";
import WebPage from "./pages/WebPage";
import BlogPage from "./pages/BlogPage";
import AllBlogsPage from "./pages/AllBlogsPage";
import ScrollToTop from "./hooks/ScrollToTop";
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminBlogPage from "./pages/Admin/AdminBlogPage";
import LoginPage from "./pages/LoginPage";
import RequireAuth from "./components/RequireAuth";
import { AuthProvider } from "./contexts/AuthProvider";
import { roles } from './enums';
import AdminMenuPage from "./pages/Admin/AdminMenuPage";
import AdminMapPage from "./pages/Admin/AdminMapPage";
import AdminEditBlogPage from "./pages/Admin/AdminEditBlogPage";
import { AxiosInterceptor } from "./services/api-axios";
import SnackbarNotificationContainer from "./pages/SnackbarNotificationContainer";
import StoreProvider from "./contexts/StoreProvider";
import LoaderContainer from "./components/LoaderContainer";
import { QueryClient, QueryClientProvider } from "react-query";
import {ThemeProvider} from "@mui/material";
import { theme } from "./styles/theme";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop>
          <AuthProvider>
            <StoreProvider>
              <ThemeProvider theme={theme}>
                <AxiosInterceptor>
                  <LoaderContainer>
                    <Routes>
                      {/* Public routes */}
                      <Route path="/" element={  <MainPage/> } />
                      <Route path="/blogs" element={<WebPage/>}>
                        <Route path="all-blogs" element={ <AllBlogsPage/>} />
                        <Route path=":blogId" element={<BlogPage/>}/>
                      </Route>
  
                      {/* Admin section routes */}
                      <Route element={<SnackbarNotificationContainer/>}>
                        <Route path="/login" element={<LoginPage/>}/>
  
                        {/* Private routes */}
                        <Route path="admin" element={<RequireAuth allowedRoles={[roles.administrator]}/>}>
                          <Route path="menu" element={<AdminMenuPage/>}/>
                          <Route path="blogs" element={<AdminBlogPage/>}/>
                          <Route path="blogs/:blogId" element={<AdminEditBlogPage/>}/>
                          <Route path="map" element={<AdminMapPage/>}/> 
                        </Route>
                      </Route>
                                      
                      {/* Missing page */}
                      <Route path="*"element={<div>Oeps, deze pagina bestaat niet</div>}/>
                    </Routes>
                  </LoaderContainer>
                </AxiosInterceptor>
              </ThemeProvider>
            </StoreProvider>
          </AuthProvider>
        </ScrollToTop>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
